import { FileSpreadsheet, FileText, Printer, Shield, X } from "lucide-react";

export default function TdsReportsExportDrawer({ open, onClose, onExcel, onCsv, onPdf, onPrint }) {
  if (!open) return null;
  return (
    <div className="tdsr-export-backdrop" role="dialog" aria-modal="true" aria-label="Export options">
      <div className="tdsr-export-drawer">
        <div className="tdsr-export-drawer__head">
          <h3>Export Report</h3>
          <button type="button" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <div className="tdsr-export-drawer__body">
          <button type="button" className="tdsr-export-option" onClick={onExcel}>
            <FileSpreadsheet size={18} />
            <span>
              <strong>Excel / CSV</strong>
              <small>Download spreadsheet for analysis</small>
            </span>
          </button>
          <button type="button" className="tdsr-export-option" onClick={onCsv}>
            <FileText size={18} />
            <span>
              <strong>CSV</strong>
              <small>Comma-separated values</small>
            </span>
          </button>
          <button type="button" className="tdsr-export-option" onClick={onPdf}>
            <FileText size={18} />
            <span>
              <strong>PDF</strong>
              <small>Print-ready document via browser</small>
            </span>
          </button>
          <button type="button" className="tdsr-export-option" onClick={onPrint}>
            <Printer size={18} />
            <span>
              <strong>Print</strong>
              <small>Send to printer</small>
            </span>
          </button>
          <div className="tdsr-export-note">
            <Shield size={14} />
            Government upload formats are available from the Compliance Center.
          </div>
        </div>
      </div>
    </div>
  );
}
